﻿

$(function () {
    var TermOfUse = function () {
        const termOfUseForm = $(".js-privacy-policy-form");

        const showLoadingIcon = () => {
            const loadingIcon = termOfUseForm.find(".loader-wrapper");
            loadingIcon.show();
        }

        termOfUseForm.validate({
            errorElement: 'div',
            errorClass: "error",
            rules: {
                AcceptTerms: {
                    required: true
                }
            },
            messages: {
                AcceptTerms: {
                    required: "Du måste godkänna användningsvillkoren"
                }
            },
            submitHandler: (form) => {
                showLoadingIcon();
                form.submit();
            }
        });

        function registerHandler() {
            if ($("#term-of-use-no").length === 0 && $("#term-of-use-yes").length === 0) {
                return;
            }

            $("#term-of-use-no").click(function () {
                var firstRejectDialog = $("#dialog-first-reject");
                firstRejectDialog.fadeIn();

                $(".back-to-term", firstRejectDialog).click(function () {
                    firstRejectDialog.fadeOut();
                });

                $(".reject", firstRejectDialog).click(function () {
                    var secondRejectDialog = $("#dialog-reconfirm-reject");
                    secondRejectDialog.fadeIn();
                    firstRejectDialog.fadeOut();

                    $(".back-to-term", secondRejectDialog).click(function () {
                        secondRejectDialog.fadeOut();
                    });

                    $(".reject", secondRejectDialog).click(function () {
                        secondRejectDialog.fadeOut();
                        $("#rejectForm").submit();
                    });
                });
            });
        }

        var setLogoutUrl = function () {
            if ($(".js-page-identifier-user-agreement").length) {
                var url = $(".js-page-identifier-user-agreement").data("logout-url");
                document.getElementById("logoutRedirect").value = location.origin + url;
            }
            else if ($(".js-page-identifier-privacy-policy").length) {
                var ppurl = $(".js-page-identifier-privacy-policy").data("logout-url");
                document.getElementById("logoutRedirect").value = location.origin + ppurl;
            }
        };

        return {
            init: function () {
                setLogoutUrl();
                registerHandler();
            }
        };
    };

    var termOfUse = new TermOfUse();
    termOfUse.init();
});
